import { Backdrop, Box, Button, CircularProgress, Grid2, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import DrawIcon from '@mui/icons-material/Draw';
import { Card, CardContent, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
const live_events_service = require('../../helpers/live_events_service')
const benefits = [
  "Conferencias por expertos en la materia, nacionales e internacionales",
  "Coffee Break’s",
  "Almuerzo",
  "Diploma de participación digital",
  "Grabación de conferencias",
  "Networking, red de contactos valioso",
];
const Tarifas = () => {
  const [evento, setEvento] = useState(null);
  const [loading, setLoading] = useState(true);
  const [contador] = useState(0)
  useEffect(() => {
    live_events_service.getData('/evento/view-by-hash/' + process.env.REACT_APP_EVT).then((response) => {
      setEvento(response.data.response_database.result[0])
      setLoading(false)
    }).catch((error) => {
      console.log(error)
    })
  }, [contador])
  return (
    <Stack spacing={5}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Box p={5}>
        <img src='https://escuela-bancaria.s3.us-east-2.amazonaws.com/d4ade41d-ccbd-41bd-8a93-0beb5c4f6c57.jpeg' style={{ width: '100%' }} />
      </Box>
      <Button
        target="_blank"
        style={{
          color: '#032E1E',
          fontSize: '1.5em',  // Aumentar el tamaño de la fuente
          padding: '12px 24px',  // Hacerlo un poco más grande
          position: 'relative',
          overflow: 'hidden',
          border: '2px solid #032E1E',  // Añadir un borde para resaltar la animación
          animation: 'pixelate 0.5s infinite alternate'
        }}
        startIcon={<DrawIcon />}
        href={'https://ebg.edu.gt/inscripcion/' + process.env.REACT_APP_EVT}
      >
        Click para registrarse
      </Button>

      <style>
        {`
    @keyframes pixelate {
        0% {
            box-shadow: 0 0 0px rgba(3, 46, 30, 0.8);
        }
        100% {
            box-shadow: 4px 4px 0px rgba(3, 46, 30, 0.8), 
                        -4px -4px 0px rgba(3, 46, 30, 0.8), 
                        4px -4px 0px rgba(3, 46, 30, 0.8), 
                        -4px 4px 0px rgba(3, 46, 30, 0.8);
        }
    }
`}
      </style>


      <Grid2 container >
        <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
          <Stack>
            <Card sx={{ maxWidth: 500, mx: "auto", boxShadow: 3, borderRadius: 3 }}>
              <CardContent>
                <Typography variant="h5" component="div" gutterBottom sx={{ fontWeight: "bold", textAlign: "center" }}>
                  Beneficios para el participante
                </Typography>
                <List>
                  {benefits.map((benefit, index) => (
                    <ListItem key={index}>
                      <ListItemIcon>
                        <CheckCircleIcon style={{ color: '#032E1E' }} />
                      </ListItemIcon>
                      <ListItemText primary={benefit} />
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>
          </Stack>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6, lg: 6 }} justifyItems='center'>
          <Box sx={{ width: { xs: '100%', md: '75%', lg: '50%' }, padding: { xs: '5%', md: '0%', lg: '0%' } }}>
            {evento != null && <img src={evento.flier} alt='flier-corefis' style={{ width: '100%' }} />}
          </Box>
        </Grid2>
      </Grid2>
    </Stack>
  )
}

export default Tarifas